import Navbar from "./components/Navbar/navbar";
import Intro from "./components/Intro/intro";
import Skills from "./components/Skills/skills";
import Experience from "./components/Experience/experience";
import Works from "./components/works/works";
import Contact from "./components/contact/contact";
import Footer from "./components/footer/footer";

function App() {
  return (
    <div className="App">
      <Navbar/> 
      <Intro/>
      <Skills/>
      <Experience/>
      <Works/>
      <Contact/>
      <Footer/>
    </div>
  );
}

export default App;
